import ProductsContractsPage from './ProductsContractsPage.component'

export default ProductsContractsPage
